import { Component, OnInit } from '@angular/core';
import { CourierOptionDefinition } from '../../../models/courier-option-definition';
import { combineLatest, Observable } from 'rxjs';
import { AppState } from '../../../store';
import { Store } from '@ngrx/store';
import { Shipment } from '../../../models/shipment';
import { selectShipmentEditorOptionIds, selectShipmentEditorShipment } from '../../../store/shipment-editor/shipment-editor.state';
import {
    shipmentEditorAddCourierOption,
    shipmentEditorRemoveCourierOption, shipmentEditorSetActiveOptions,
} from '../../../store/shipment-editor/shipment-editor.actions';
import { selectCourierOptions, selectSelectableCourierOptions } from '../../../store/profile/profile.state';
import { map } from 'rxjs/operators';
import { MatSelectionListChange, MatSelectionList, MatListOption } from '@angular/material/list';
import { MatLine } from '@angular/material/core';
import { AsyncPipe } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { OptionTagEnum } from '../../../enum/option-tag.enum';

@Component({
    selector: 'app-courier-option-menu',
    templateUrl: './courier-option-menu.component.html',
    styleUrls: [ './courier-option-menu.component.scss' ],
    imports: [ MatSelectionList, MatListOption, AsyncPipe ]
})
export class CourierOptionMenuComponent implements OnInit {

    options$: Observable<CourierOptionDefinition[]>;

    constructor(private store: Store<AppState>) {}

    selectedOptions$ = this.store.select(selectShipmentEditorOptionIds);

    matchOptionToShipment(option: CourierOptionDefinition, shipment: Shipment): boolean {
        if (option.requirePackaging.length > 0) {
            if (!option.requirePackaging.includes(shipment.packagingType)) {
                return false;
            }
        }
        if (option.excludePackaging.length > 0) {
            if (option.excludePackaging.includes(shipment.packagingType)) {
                return false;
            }
        }
        if (option.requireInternational) {
            if (shipment.shipper.country === shipment.destination.country) {
                return false;
            }
        }
        return true;
    }

    ngOnInit(): void {
        this.options$ = combineLatest([
            this.store.select(selectSelectableCourierOptions), this.store.select(selectShipmentEditorShipment)
        ]).pipe(
            map(([ options, shipment ]) => options.filter(o => this.matchOptionToShipment(o, shipment)))
        );
    }

    change(change: MatSelectionListChange): void {
        this.store.dispatch(shipmentEditorSetActiveOptions({ options: change.source.selectedOptions.selected.map(s => s.value) }));
    }

}
